import { KyInstance } from 'ky';

import { buildSearchParams, handleRequest } from '@/utils/httpUtils';

import {
  CO2SavedResponse,
  CommonDestinationsResponse,
  CreatedDailyResponse,
  CreatedHourResponse,
  DeliveredDTResponse,
  FastestDeliveriesResponse,
  GetCO2Saved,
  GetCommonDestinations,
  GetCreatedDaily,
  GetCreatedHour,
  GetDeliveredDT,
  GetFastestDeliveries,
  GetOrdersByStatus,
  GetUnsuccessfulCollections,
  GetUnsuccessfulDeliveries,
  OrdersByStatusResponse,
  UnsuccessfulCollectionsResponse,
  UnsuccessfulDeliveriesResponse,
} from './types';

export interface IReqDashboard {
  co2Saved: GetCO2Saved;
  commonDestinations: GetCommonDestinations;
  createdDaily: GetCreatedDaily;
  createdHour: GetCreatedHour;
  deliveredDT: GetDeliveredDT;
  fastestDeliveries: GetFastestDeliveries;
  orderByStatus: GetOrdersByStatus;
  unsuccessfulCollections: GetUnsuccessfulCollections;
  unsuccessfulDeliveries: GetUnsuccessfulDeliveries;
}

export function reqDashboard(http: KyInstance): IReqDashboard {
  const route = 'api/orders/dashboard';
  return {
    co2Saved: async ({ startDate, endDate }) => {
      if ((startDate && !endDate) || (!startDate && endDate))
        return Promise.reject('Invalid date range');

      return handleRequest<CO2SavedResponse>(http, 'get', `${route}/co2-saved`, {
        searchParams: buildSearchParams({ startDate, endDate }),
      });
    },
    commonDestinations: async ({ startDate, endDate }) => {
      if ((startDate && !endDate) || (!startDate && endDate))
        return Promise.reject('Invalid date range');

      return handleRequest<CommonDestinationsResponse>(
        http,
        'get',
        `${route}/common-destinations`,
        {
          searchParams: buildSearchParams({ startDate, endDate }),
        },
      );
    },
    createdDaily: async ({ startDate, endDate }) => {
      if ((startDate && !endDate) || (!startDate && endDate))
        return Promise.reject('Invalid date range');

      return handleRequest<CreatedDailyResponse>(http, 'get', `${route}/created-daily`, {
        searchParams: buildSearchParams({ startDate, endDate }),
      });
    },
    createdHour: async ({ startDate, endDate }) => {
      if ((startDate && !endDate) || (!startDate && endDate))
        return Promise.reject('Invalid date range');

      return handleRequest<CreatedHourResponse>(http, 'get', `${route}/created-hour`, {
        searchParams: buildSearchParams({ startDate, endDate }),
      });
    },
    deliveredDT: async ({ startDate, endDate }) => {
      if ((startDate && !endDate) || (!startDate && endDate))
        return Promise.reject('Invalid date range');

      return handleRequest<DeliveredDTResponse>(http, 'get', `${route}/delivered-dt`, {
        searchParams: buildSearchParams({ startDate, endDate }),
      });
    },
    fastestDeliveries: async ({ startDate, endDate }) => {
      if ((startDate && !endDate) || (!startDate && endDate))
        return Promise.reject('Invalid date range');

      return handleRequest<FastestDeliveriesResponse>(http, 'get', `${route}/fastest-deliveries`, {
        searchParams: buildSearchParams({ startDate, endDate }),
      });
    },
    orderByStatus: async ({ startDate, endDate }) => {
      if ((startDate && !endDate) || (!startDate && endDate))
        return Promise.reject('Invalid date range');

      return handleRequest<OrdersByStatusResponse>(http, 'get', `${route}/orders-by-status`, {
        searchParams: buildSearchParams({ startDate, endDate }),
      });
    },
    unsuccessfulCollections: async ({ startDate, endDate }) => {
      if ((startDate && !endDate) || (!startDate && endDate))
        return Promise.reject('Invalid date range');

      return handleRequest<UnsuccessfulCollectionsResponse>(
        http,
        'get',
        `${route}/unsuccessful-collections`,
        {
          searchParams: buildSearchParams({ startDate, endDate }),
        },
      );
    },
    unsuccessfulDeliveries: async ({ startDate, endDate }) => {
      if ((startDate && !endDate) || (!startDate && endDate))
        return Promise.reject('Invalid date range');

      return handleRequest<UnsuccessfulDeliveriesResponse>(
        http,
        'get',
        `${route}/unsuccessful-deliveries`,
        {
          searchParams: buildSearchParams({ startDate, endDate }),
        },
      );
    },
  };
}
